export enum Environments {
  LOCAL = 'local',
  DEV = 'dev',
  INTE = 'col',
  QA = 'qa',
  PROD = 'prod'
}
export const UHHosts: Map<string, string> = new Map<string, string>([
  [Environments.LOCAL, "http://localhost:5000"], //proxy
  [Environments.DEV, window.location.host.startsWith('sitowordpress') ? 'https://syugbovapigw-svil.servizi.gr-u.it' : `${window.location.protocol}//${window.location.host}`],
  [Environments.INTE,  window.location.host.startsWith('sitowordpress') ? 'https://syugbovapigw-inte.unipol.it' : `${window.location.protocol}//${window.location.host}`],
  [Environments.QA,  window.location.host.startsWith('sitowordpress') ? 'https://syugbovapigw-coll.unipol.it' : `${window.location.protocol}//${window.location.host}`],
  [Environments.PROD,  window.location.host.startsWith('sitowordpress') ? 'https://api.unipolsai.it' : `${window.location.protocol}//${window.location.host}`
  ]
]);
export const UHBasePaths: Map<string, string> = new Map<string, string>([
  [Environments.LOCAL, "/unipolhome/sviluppo/api/v1"], //proxy
  [Environments.DEV, window.location.host.startsWith('sitowordpress') ? '/unipolhome/sviluppo/api/v1' : '/api/uh/pub/api/v1'],
  [Environments.INTE, window.location.host.startsWith('sitowordpress') ? '/unipolhome/integrazione/api/v1' : '/api/uh/pub/api/v1'],
  [Environments.QA, window.location.host.startsWith('sitowordpress') ? '/unipolhome/collaudo/api/v1' : '/api/uh/pub/api/v1'],
  [Environments.PROD, window.location.host.startsWith('sitowordpress') ? '/unipolhome/produzione/api/v1' : '/api/uh/pub/api/v1']
]);
export const UHSupportBasePath: Map<string, string> = new Map<string, string>([
  [Environments.LOCAL, "/app/"], //proxy
  [Environments.DEV, "/app/"],
  [Environments.INTE, "/app/"],
  [Environments.QA, "/app/"],
  [Environments.PROD, "/app/"
  ]
]);



type UHEnvHeaders = {
  LOCAL: ApiConnectHeaders;
  DEV: ApiConnectHeaders;
  INTE: ApiConnectHeaders;
  QA: ApiConnectHeaders;
  PROD: ApiConnectHeaders;
};

export const UHHeaders: UHEnvHeaders = {
  LOCAL: {
    CLIENTID: php_pars.apiConfig[Environments.LOCAL]?.CLIENTID,
    CLIENTSECRET: php_pars.apiConfig[Environments.LOCAL]?.CLIENTSECRET,
  },
  DEV: {
    CLIENTID: php_pars.apiConfig[Environments.DEV]?.CLIENTID,
    CLIENTSECRET: php_pars.apiConfig[Environments.DEV]?.CLIENTSECRET,
  },
  INTE: {
    CLIENTID: php_pars.apiConfig[Environments.INTE]?.CLIENTID,
    CLIENTSECRET: php_pars.apiConfig[Environments.INTE]?.CLIENTSECRET,
  },
  QA: {
    CLIENTID: php_pars.apiConfig[Environments.QA]?.CLIENTID,
    CLIENTSECRET: php_pars.apiConfig[Environments.QA]?.CLIENTSECRET,
  },
  PROD: {
    CLIENTID: php_pars.apiConfig[Environments.PROD]?.CLIENTID,
    CLIENTSECRET: php_pars.apiConfig[Environments.PROD]?.CLIENTSECRET,
  },
};
